import temp_1 from './templates/temp1'
import temp_2 from './templates/temp2'
//import temp_3 from './templates/temp3'
//import temp_4 from './templates/temp4'
//import temp_5 from './templates/temp5'

export default class Templates {
  static temp1 = temp_1.css

  static temp2 = temp_2.css

  //static temp3 = temp_3.css

  //static temp4 = temp_4.css

  //static temp5 = temp_5.css
}
